/**
 * Debounce function. Used to throttle the calling of multiple subsequent functions.
 * @param func
 * @param wait
 * @param immediate
 */
export function debounce(func: any, wait: number, immediate = false) {
  let timeout: any;
  return function () {
    // @ts-ignore
    let context = this;
    let args = arguments;
    clearTimeout(timeout);
    timeout = setTimeout(function () {
      timeout = null;
      if (!immediate) func.apply(context, args);
    }, wait);
    if (immediate && !timeout) func.apply(context, args);
  };
}
